import { GenIcon } from '../helpers/IconBase.es.js';

const FingerPrintOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M4.52507 6.98901C3.23648 8.91157 2.68561 11.3278 3.17924 13.7759",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.0917 3.98698C14.3444 3.09249 12.2935 2.76107 10.2196 3.17923C8.50862 3.52421 7.00974 4.33343 5.82764 5.44929",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.8162 10.2196C20.3916 8.11396 19.264 6.32956 17.7271 5.06152",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.9983 12.1788C21.0107 11.5338 20.9536 10.8774 20.8208 10.2188",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M3.18408 13.7749C3.21015 13.904 3.23883 14.032 3.27015 14.1587",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.67529 20.6898C11.6906 18.396 12.6502 15.2213 12.0001 11.9973",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12.2848 20.9895C14.1058 18.3283 14.9316 14.5174 14.2046 11.5528C13.8748 10.1879 12.7724 9.54159 11.552 9.7877C10.3317 10.0338 9.5488 11.1655 9.79507 12.4417C10.3379 15.2546 9.37823 17.9536 7.44922 19.7584",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.69019 13.6311C7.81349 15.4803 7.01244 17.2297 5.63525 18.3578",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.6515 12.813C16.6048 12.2473 16.5247 11.6783 16.4098 11.1082L16.4104 11.1077C15.919 8.6706 13.5452 7.09343 11.1083 7.5848C9.11583 7.98656 7.69812 9.64646 7.51562 11.5705",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.2251 20.3953C16.0572 18.6873 16.5622 16.8097 16.676 14.8584",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.93815 5.57031C6.70346 6.60258 4.69568 9.92587 5.38237 13.3316L5.38585 13.3308C5.63803 14.5817 5.16426 15.8103 4.25488 16.5809",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.3836 18.3345C19.0311 15.9056 19.1449 13.2946 18.6144 10.6638L18.6132 10.6637C17.9669 7.45832 15.1488 5.24522 12 5.24756",
          stroke: "#82869E",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { FingerPrintOutlined };
